// material
// components
import {Box, Container, Stack, Tab, Tabs, Typography} from '@mui/material';
import {useState} from 'react';
import Page from 'src/components/Page';
import {TabPanel} from 'src/components/TabPanel';
import AdditionalInfoForm from 'src/components/_dashboard/UpdateSite/AdditionalInfoForm.js';
import BasicInfoForm from 'src/components/_dashboard/UpdateSite/BasicInfoForm.js';
import VisitSite from 'src/components/VisitSite.js';
import StoreDesign from '../components/StoreDesign.js';
import UpdateOrderSettings from 'src/components/_dashboard/UpdateSite/UpdateOrderSettings.js';
import {useSearchParams} from 'react-router-dom';
import {getNumber} from 'src/utils/numberUtils.js';

export default function UpdateSite() {
	const [qparams, setQparams] = useSearchParams({tab: 0});
	const value = getNumber(qparams.get('tab'));
	const handleChange = (event, newValue) => {
		setQparams({tab: newValue});
	};
	return (
		<Page title="المتجر">
			<Container>
				<Stack direction="row" justifyContent="space-between" alignItems="center">
					<Typography variant="h3">المتجر </Typography>
					<VisitSite text="عرض المتجر" />
				</Stack>

				<Box sx={{borderBottom: 1, mb: 1, borderColor: 'divider'}}>
					<Tabs
						variant="scrollable"
						value={value}
						onChange={handleChange}
						aria-label="basic tabs example"
					>
						<Tab label="اعدادات الموقع الاساسية" />
						<Tab label="اعدادات اضافية" />
						<Tab label="اعدادات الطلبات" />
						<Tab label="تصميم الموقع" />
					</Tabs>
				</Box>
				<TabPanel index={0} value={value}>
					<BasicInfoForm />
				</TabPanel>
				<TabPanel index={1} value={value}>
					<AdditionalInfoForm />
				</TabPanel>
				<TabPanel index={2} value={value}>
					<UpdateOrderSettings />
				</TabPanel>
				<TabPanel index={3} value={value}>
					<StoreDesign />
				</TabPanel>
			</Container>
		</Page>
	);
}
